import { render, staticRenderFns } from "./AccountSwitch.vue?vue&type=template&id=7ce2a630"
import script from "./AccountSwitch.vue?vue&type=script&lang=js"
export * from "./AccountSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports